import { VHeaders } from '@/models/pagedlistmodel';

export function getVantiAccountHeaders(vm: any): VHeaders[] {
  return [
    {
      text: vm.$parent.$t(
        'vantivAccounts.vantivAccountGridHeaders.description'
      ) as string,
      align: 'left',
      value: 'typeDesc',
      sortable: true,
    },
    {
      text: vm.$parent.$t(
        'vantivAccounts.vantivAccountGridHeaders.accountId'
      ) as string,
      align: 'left',
      value: 'accountId',
      sortable: true,
    },
    {
      text: vm.$parent.$t(
        'vantivAccounts.vantivAccountGridHeaders.acceptorId'
      ) as string,
      align: 'left',
      value: 'acceptorId',
      sortable: true,
    },
    {
      text: vm.$parent.$t(
        'vantivAccounts.vantivAccountGridHeaders.accountToken'
      ) as string,
      align: 'left',
      value: 'accountToken',
      sortable: true,
    },
    {
      text: vm.$parent.$t(
        'vantivAccounts.vantivAccountGridHeaders.action'
      ) as string,
      isNotDataProp: true,
      align: 'center',
      sortable: false,
    },
  ];
}
